


























import {
    Vue,
    Component
} from "@/shared/vuepack";
import { useDebitCardManagementStore } from "@/shared/store/debitCardManagement";
import * as datadog from "@/shared/datadog";
import { Address } from "@/shared/types";
import { useThemeStore } from "@/shared/store/theme";

@Component({
    components: {
    }
})
export default class RequestNewCardCompleteForm extends Vue {
    debitCardManagementStore = useDebitCardManagementStore();
    themeStore = useThemeStore();

    get mailingAddress (): Address {
        return this.debitCardManagementStore.mailingAddress;
    }

    onClose () {
        this.debitCardManagementStore.setPotentialNewCardHolder(null);
        this.debitCardManagementStore.closeModal();
    }
}
